@if (params.value) {
  <span class="active {{fieldName}}">{{params.active}}</span>
} @else {
  <span class="not-active {{fieldName}}">{{params.notActive}}</span>
}
<ng-template #notActive>
  <span class="not-active {{fieldName}}">{{params.notActive}}</span>
</ng-template>
